import { Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AbstractSpecificFieldComponent } from '../abstract-specific-field.component';

const RD_TRUE = 'Oui';
const RD_FALSE = 'Non';
const ELIGIBLE_HABILITATIONS = ['ALPSI', 'CIF'];

@Component({
  selector: 'app-reinvestissement-dividendes',
  templateUrl: './reinvestissement-dividendes.component.html',
  styleUrls: ['./reinvestissement-dividendes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReinvestissementDividendesComponent extends AbstractSpecificFieldComponent<string> {
  @Input() override touchNonce?: number;

  rdControl = new FormControl<boolean>(false);
  isEligibleHabilitation: boolean = true;

  override getDataName(): string {
    return 'reinvestissementDividendes';
  }

  override wrapData(value: string): string {
    return value;
  }

  override isFormValid(): boolean {
    return this.rdControl.valid;
  }

  private wrapValue(value: boolean): string {
    return value ? RD_TRUE : RD_FALSE;
  }

  private computeIsEligibleHabilitation(): boolean {
    const code = this.operation?.produit?.habilitationNavigation?.code?.toUpperCase();

    // Keep the field visible when code is unavailable to avoid hiding it on incomplete product payloads.
    if (!code) {
      return true;
    }

    return ELIGIBLE_HABILITATIONS.includes(code);
  }

  private hasInitialValue(): boolean {
    const initialValue = this.initialData?.data?.[this.getDataName()];
    return initialValue === RD_TRUE || initialValue === RD_FALSE;
  }

  override ngOnInit(): void {
    this.isEligibleHabilitation = this.computeIsEligibleHabilitation();

    if (!this.isEligibleHabilitation) {
      this.onDataChange({
        dataSource: this.getDataName(),
        data: { isFormValid: true, data: {} },
      });
      return;
    }

    this.rdControl.valueChanges.subscribe(value => {
      if (value != null) {
        this.metadata[this.getDataName()] = this.wrapValue(value);
        this.onDataChange({
          dataSource: this.getDataName(),
          data: { isFormValid: this.isFormValid(), data: this.metadata },
        });
      }
    });

    if (!this.hasInitialValue()) {
      this.rdControl.setValue(false);
    }
  }

  override ngOnChanges(changes: SimpleChanges): void {
    this.isEligibleHabilitation = this.computeIsEligibleHabilitation();

    if (!this.isEligibleHabilitation) {
      return;
    }

    const data = changes['initialData']?.currentValue;
    if (data) {
      const dataValueString = data.data[this.getDataName()];
      if (dataValueString) {
        const value: string = this.wrapData(dataValueString);
        const booleanValue = value === RD_TRUE;
        this.rdControl.setValue(booleanValue);
      }
    }

    if (changes['touchNonce'] && !changes['touchNonce'].firstChange) {
      this.rdControl.markAsTouched();
      this.rdControl.updateValueAndValidity({ onlySelf: true });
    }
  }
}
